import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { get } from 'lodash';
import { RootState } from 'modules';
import RefundRequestModal from 'components/user/parts/RefundRequestModal';
import { getMenteePurchaseLog } from 'libs/api/user';
import { useDataApi, usePagination, useTimezone } from 'libs/hooks';
import { numberToKorean } from 'libs/utils';
import { TListResponse, TPagination } from 'modules/types';
import { TModalState } from 'modules/types';
import { TUser, TPurchaseLog } from 'modules/user';
import { CWindowWidth, CDateFormat } from 'constants/base.const';
import { List } from 'antd';
import styled from 'styled-components';
import { PrimaryColor, SecondaryColor, Colors, device } from 'GlobalStyles';

const PurchaseHistory = () => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [pagination, setPagination] = usePagination(10);
  const reloadPage = (page?: Partial<TPagination>) => {
    setPagination({
      ...pagination,
      ...page,
    });
  };

  const getPromise = getMenteePurchaseLog.bind(null, {
    field: {
      mentoring_field: currentUser?.primary_field,
    },
    params: {
      current: pagination.current,
      pageSize: pagination.pageSize,
      q: pagination.q,
    },
  });
  const [{ data, loading }, setCallback] = useDataApi<TListResponse<TPurchaseLog>>(getPromise, {
    contents: [],
    last: false,
  });

  const [getDateTime, timezone] = useTimezone();
  const [refundModalState, setRefundModalState] = useState<TModalState>({
    visible: false,
  });

  useEffect(() => {
    //구매 취소 모달을 띄운 뒤 모달이 꺼졌을 경우 다시 페이지네이션 데이터 불러와야 결제취소가 제대로 뜬다
    if (!refundModalState.visible) setCallback(() => getPromise);
  }, [pagination, refundModalState]);

  return (
    <StyledPurchaseHistoryWrapper
      style={{
        maxWidth: `${CWindowWidth - 400}px`,
        padding: '20px 10px',
        margin: 'auto',
      }}
    >
      <RefundRequestModal modalState={refundModalState} setModalState={setRefundModalState} />
      <div
        style={{
          fontSize: '16px',
          fontWeight: 'bold',
          color: SecondaryColor,
        }}
      >
        결제 내역
      </div>

      <List
        pagination={{
          ...pagination,
          total: get(data, 'total', 0),
          position: 'bottom',
          hideOnSinglePage: true,
          onChange: (page) => {
            reloadPage({
              current: page,
              pageSize: pagination.pageSize,
            });
          },
        }}
        loading={loading}
        dataSource={get(data, 'contents')}
        renderItem={(item) => (
          <StyledListItem>
            <StyledListItemContents>
              <div>
                <span className='created_at'>{getDateTime(get(item, 'created_at')).format(CDateFormat)}</span>
                <span>
                  {' '}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {get(item, 'product_name')}
                </span>
              </div>
              <div
                style={{
                  width: '80px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <span>
                  {/* {String(get(item, 'amount'))
                    .replace('.00', '')
                    .replace('0000', '만')} */}
                  {String(numberToKorean(Number(String(get(item, 'amount')).replace('.00', '')))).replace(
                    ',000',
                    '천',
                  )}
                  원
                </span>
                {!get(item, 'is_canceled_order') && get(item, 'is_able_to_cancel') && (
                  <StyledCancelText
                    style={{
                      color: PrimaryColor,
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                    onClick={() => setRefundModalState({ visible: true, record: item })}
                  >
                    결제취소
                  </StyledCancelText>
                )}
                {get(item, 'is_canceled_order') && (
                  <StyledCancelText
                    style={{
                      color: Colors.grey2,
                    }}
                  >
                    취소 완료
                  </StyledCancelText>
                )}
              </div>
            </StyledListItemContents>
          </StyledListItem>
        )}
      />
    </StyledPurchaseHistoryWrapper>
  );
};

export default PurchaseHistory;

const StyledPurchaseHistoryWrapper = styled.div`
  max-width: 400px;
  & .ant-list-items {
    border: 1px solid ${Colors.grey1};
    border-radius: 10px;
    padding: 0 20px;
  }
`;

const StyledListItem = styled.div`
  /* font-size: 1rem; */
  color: #000;
`;

const StyledListItemContents = styled.div`
  padding: 10px 0px;
  border-top: 1px solid ${Colors.grey0};
  /* margin: 0; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.9rem;
  @media screen and ${device.lg} {
    font-size: 0.7rem;
  }

  & .created_at {
    color: ${Colors.grey3};
  }
`;

const StyledCancelText = styled.span`
  font-size: 0.9rem;
  @media screen and ${device.lg} {
    font-size: 0.7rem;
  }
`;
